import { useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";

import HeroSectionTreatment, {
    filterAvailableJiraSites
} from "@/components/hero-variant-ATLAS-53087/hero-variant-ATLAS-53087";
import BannerAlert, { BannerProps } from "@/components/wpl/banner-alert/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import GlobalFooter from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import { JiraSoftwarePageProps } from "../../../../pages/jira-software-page/jira-software-page";
import {
    BlogsSection,
    CTASection,
    DevOpsSection,
    HeroSectionControl,
    IntegrationSection,
    ScalingSection,
    JiraSoftwareNav,
    TabsSection,
    WorkflowSection
} from "../sections/productionized";

export const JiraProductTourOverview = ({
    availableProducts,
    userProfile
}: JiraSoftwarePageProps) => {
    const intl = useIntl();
    const availableJiraSites = filterAvailableJiraSites(availableProducts);

    const bannerMessages: BannerProps = {
        identifier: "jira-software.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.banner-alert.text",
            defaultMessage:
                "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };

    let showLoggedInWelcomeMessage;
    // @ts-ignore
    // TODO: Ignoring unused var for now until SPICE-1118
    let showLoginModalJswProductTour;

    if (userProfile && availableJiraSites.length > 0) {
        // ATLAS-53087: Show welcome message and product link to logged in users
        showLoggedInWelcomeMessage = FeatureGates.getExperimentValue(
            "get_logged_in_users_back_into_jsw_faster_exp",
            "showLoggedInWelcomeMessage",
            false
        );
    } else {
        // ATLAS-45338: Target users to increase logins
        // Only seek to enroll a user in this experiment if they are detected to be Logged OUT
        showLoginModalJswProductTour = FeatureGates.getExperimentValue(
            "get_logged_out_users_back_into_jsw_faster_exp",
            "showLoginModalJswProductTour",
            false
        );
    }

    const HeroSection = showLoggedInWelcomeMessage ? (
        <HeroSectionTreatment
            availableJiraSites={availableJiraSites}
            userProfileName={userProfile?.name}
        />
    ) : (
        <HeroSectionControl />
    );

    return (
        <div>
            <div>
                <GlobalNavigation
                    showTryNow={false}
                    color={"#f4f5f7"}
                    productKey="jiraSoftware"
                />
            </div>
            <JiraSoftwareNav />

            <BannerAlert
                identifier={bannerMessages.identifier}
                text={bannerMessages.text}
                linkUrl={bannerMessages.linkUrl}
                linkText={bannerMessages.linkText}
            />
            {HeroSection}
            <TabsSection />
            <WorkflowSection />
            <IntegrationSection />
            <DevOpsSection />
            <BlogsSection />
            <ScalingSection />
            <CTASection />
            <GlobalFooter />
        </div>
    );
};
